/** Public recovery page. It is not inside PrivateRouteWrapper. */
export const PUBLIC_PASSWORD_RESET_PATH = '/reset-password/:id';

export function isPublicPasswordResetRoute(pathname: string | null | undefined): boolean {
    return /^\/reset-password\/[^/]+$/.test(pathname || '');
}
